import { useState } from "react";
import { useTranslation } from 'react-i18next';
import Modal from "react-bootstrap/Modal";
import "./SupportForm.css";

// Headset "Support": opens RevRex Help (help pages, assistant, Contact support, My tickets) in a side panel.
// Help lives on the RevRex App host (…app.revrex.com/help/) and signs in with the RevRex App session,
// which it can read from here because both hosts are under revrex.com.
const HELP_URL = process.env.REACT_APP_HELP_URL || `${process.env.REACT_APP_REVREX_APP_BASE_URL}/help/`;

interface SupportFormProps {
  show?: boolean;
  onShow?: () => void;
  onHide?: () => void;
}

export default function SupportForm({ show: controlledShow, onHide }: SupportFormProps) {
  const { t } = useTranslation('components.SupportForm');
  const [show, setShow] = useState(false);
  const isOpen = controlledShow ?? show;

  const close = () => {
    if (onHide) {
      onHide();
      return;
    }
    setShow(false);
  };

  // ?panel opens the assistant next to the help; ?from tells support which GL page the user was on.
  const src = `${HELP_URL}?panel=1&from=${encodeURIComponent('GL ' + window.location.pathname)}`;

  return (
    <>
      <Modal show={isOpen} onHide={close} dialogClassName="rx-help-drawer">
        {/* Floating close on the drawer's outer edge: the help gets the full height */}
        <button onClick={close} className="support-close" aria-label={t('close')} title={t('close')}>×</button>
        <Modal.Body>
          {isOpen && <iframe src={src} title="RevRex Help" />}
        </Modal.Body>
      </Modal>
    </>
  );
}
